import Vue from 'vue';

Vue.filter('tailing', function(value, tail) {
    return value + tail;
});
